import { render, staticRenderFns } from "./PropertyDetailsButton.vue?vue&type=template&id=cdf68264&scoped=true"
import script from "./PropertyDetailsButton.vue?vue&type=script&lang=js"
export * from "./PropertyDetailsButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf68264",
  null
  
)

export default component.exports